var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mortgage-result-broker"
  }, [_c('div', {
    staticClass: "mortgage-parameters"
  }, [_c('img', {
    staticClass: "bank-logo",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.application.bank.logo_square,
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "bold wrap100px",
    "class": {
      'red-text-custom': _vm.application.backEndLimitCorrected
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.getTotalAmountBasedOnCorrection())) + " EUR ")]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm.application.fix) + " ")]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm._f("toFloor")(_vm.application.sadzba_pozadovana, 2))), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]), _c('div', {
    staticClass: "bold wrap100px"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.application.splatka)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm.application.splatnost) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("R")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.application.poplatok_za_poskytnutie)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "d-flex MGtop20px"
  }, [_c('div', {
    staticClass: "text-cta",
    on: {
      "click": function click($event) {
        return _vm.deleteApplication();
      }
    }
  }, [_vm._v(" Zrušiť ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }